import { render, staticRenderFns } from "./examRoutineList.vue?vue&type=template&id=bd5bf0e2&"
import script from "./examRoutineList.vue?vue&type=script&lang=js&"
export * from "./examRoutineList.vue?vue&type=script&lang=js&"
import style0 from "./examRoutineList.vue?vue&type=style&index=0&id=bd5bf0e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports